import Login from '@/views/Login.vue'
import NotFound from '@/views/NotFound.vue'
import Index from '@/views/Index.vue'
import {isMobile} from "@/api/order";
import MLogin from "@/views/MLogin";

let routMap = null;

if (isMobile() || process.env.NODE_ENV === 'apkenv') {
    routMap = [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: MLogin
        }
    ];
} else {
    routMap = [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        }
    ];
}

export const StaticRoutesMap = routMap;


export const NotFoundRoute = {
    path: '*',
    name: '404',
    component: NotFound
}


// export const IndexRoute = {
//     path: '/admin/index',
//     name: 'index',
//     component: Index
// }